export default "__VITE_ASSET__C$YU0qS6__"